<template>
  <div>
    <div class="app" v-cloak>
      <!--      <transition :name="transitionName">-->
      <keep-alive :include="include" :max="10">
        <!-- <Header v-if="footer === false" title="nnn"></Header> -->
        <router-view class="router" ref="router"></router-view>
      </keep-alive>
      <!--      </transition>-->
    </div>
    <Footer v-if="footer === true"></Footer>
    <Home v-if="home === true && home === false"></Home>
  </div>
</template>
<script>
function isKeepAlive($route) {
  return $route.meta.keepAlive === undefined || $route.meta.keepAlive;
}
import { loginAuto } from "@api/user";
// import Header from "@components/Header";
import Footer from "@components/Footer";
import Home from "@components/Home";
import { mapGetters } from "vuex";
// import { openShareAll } from "@libs/wechat";
// import { getShare } from "@api/public";
import { isWeixin, VUE_APP_VERSION } from "@utils/index";

export default {
  data() {
    return {
      v: VUE_APP_VERSION,
      transitionName: "fold-right",
      include: isKeepAlive(this.$route) ? [this.$route.name] : [],
      history: []
    };
  },
  provide() {
    return {
      app: this
    };
  },
  computed: mapGetters(["footer", "home", "isLogin"]),
  components: {
    // Header,
    Footer,
    Home
  },
  watch: {
    $route(to, from) {
      const lastPath = this.history[this.history.length - 1] || {},
        { isReplace, isBack } = this.$router;

      if (lastPath.path === to.path) {
        this.transitionName = "fold-right";
        this.history.pop();
      } else {
        this.transitionName = "fold-left";
        if (!isReplace) this.history.push({ path: from.path, name: from.name });
      }

      if (isKeepAlive(to) && to.name !== "Login") {
        !this.include.includes(to.name) && this.include.push(to.name);
      }

      if (isKeepAlive(from) && isBack) {
        var index = this.include.indexOf(from.name);
        index !== -1 && this.include.splice(index, 1);
      }

      this.$router.isBack = false;
      this.$router.isReplace = false;

      // console.log(this.transitionName, "change");
    }
  },
  mounted: function() {
    this.loginAuto();
    this.setOpenShare();
    let path = this.$route.name;
    console.log("mounted", path);
    // this.checkAgreement();
  },
  methods: {
    checkAgreement() {
      let path = this.$route.name;
      console.log("checkAgreement", path);
      let Agreement = localStorage.getItem("Agreement");
      if (
        !Agreement &&
        path != "Agreement1" &&
        path != "Agreement2" &&
        path != "Agreement3" &&
        path != "Reg"
      ) {
        this.$router.push({ path: "/agreement" });
      }
    },
    loginAuto: function() {
      let account = localStorage.getItem("account");
      //如果没有登录，并且存有账号信息，自动登录
      if (!this.$store.state.app.token && account) {
        loginAuto({
          account
        })
          .then(({ data }) => {
            let expires_time = data.expires_time.substring(0, 19);
            expires_time = expires_time.replace(/-/g, "/");
            expires_time = new Date(expires_time).getTime() - 28800000;
            const datas = {
              token: data.token,
              expires_time: expires_time
            };
            this.$store.commit("LOGIN", datas);
          })
          .catch(e => {
            this.$dialog.error(e.msg);
          });
      }
    },
    setOpenShare: function() {
      // if (isWeixin()) {
      //   getShare().then(res => {
      //     var data = res.data.data;
      //     var configAppMessage = {
      //       desc: data.synopsis,
      //       title: data.title,
      //       link: location.href,
      //       imgUrl: data.img
      //     };
      //     openShareAll(configAppMessage);
      //   });
      // }
    }
  }
};
</script>
<style lang="scss">
// .app {
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   // height: 100%;
//   padding: 0;
//   margin: 0;
//   overflow-x: hidden;
// }
[v-cloak] {
  display: none !important;
}

.router {
  position: absolute;
  width: 100%;
}

.fold-left-enter-active {
  animation-name: fold-left-in;
  animation-duration: 0.5s;
}

.fold-left-leave-active {
  animation-name: fold-left-out;
  animation-duration: 0.5s;
}

@keyframes fold-left-in {
  0% {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
  10% {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fold-left-out {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  10% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  100% {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}

.fold-right-enter-active {
  animation-name: fold-right-in;
  animation-duration: 0.5s;
}

.fold-right-leave-active {
  animation-name: fold-right-out;
  animation-duration: 0.5s;
}

@keyframes fold-right-in {
  0% {
    width: 100%;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
  10% {
    width: 100%;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
  100% {
    width: 100%;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fold-right-out {
  0% {
    width: 100%;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  10% {
    width: 100%;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  100% {
    width: 100%;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}
</style>
